import { render, staticRenderFns } from "./updateBLLC.vue?vue&type=template&id=57a1243a&lang=pug&"
import script from "./updateBLLC.vue?vue&type=script&lang=js&"
export * from "./updateBLLC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports